import { render, staticRenderFns } from "./datamessage.vue?vue&type=template&id=11fc53ac&scoped=true"
import script from "./datamessage.vue?vue&type=script&lang=js"
export * from "./datamessage.vue?vue&type=script&lang=js"
import style0 from "./datamessage.vue?vue&type=style&index=0&id=11fc53ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc53ac",
  null
  
)

export default component.exports